// extracted by mini-css-extract-plugin
export default {"deliveryInfoWrapper":"_2SmfBORvprcicGSFSzQiiu","infoParagraph":"_12qX9SHvOjwKUapZzcHHaK","infoTitle":"_3B1J6rk81OiWX28AJ8cN-l"};